// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U3cvsmVXnKTgLT {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  height: 20px;
  margin-top: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-075, 5px);
  border-radius: var(--ds-radius-xsmall, 2px);
  background-color: var(--ds-background-information-bold, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
  line-height: 20px;
  text-align: center;
}
`, ""]);
// Exports
export var tag = `U3cvsmVXnKTgLT`;
export default ___CSS_LOADER_EXPORT___;
